<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="1024">
    <kendo-dialog-titlebar>
        <h3>{{ 'EDIT-EMAIL-TEMPLATE' | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm" style="margin-bottom:-10px">
        <kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)">
            <kendo-tabstrip-tab [selected]="true">
                <ng-template kendoTabTitle>
                    <i class="fas fa-pencil-ruler"></i>&nbsp;{{ 'FORM-DESIGN' | translate }}
                </ng-template>
                <ng-template kendoTabContent>
                    <div class="k-form">
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field mt-0">
                                    <span class="k-text-uppercase dark">
                                        {{'EMAIL-TEMPLATE-TYPE' | translate}}
                                    </span>
                                    <input id="name" kendoTextBox formControlName="type" />
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field mt-0">
                                    <span class="k-text-uppercase dark">
                                        {{'EMAIL-TEMPLATE-MIME-TYPE' | translate}}
                                    </span>
                                    <input *ngIf="!isAllowAddUpdate()" id="mimeType" kendoTextBox
                                        formControlName="mimeType" />
                                    <kendo-combobox *ngIf="isAllowAddUpdate()" formControlName="mimeType"
                                        [data]="templateMimeTypes" [textField]="'text'" [valueField]="'value'"
                                        [valuePrimitive]="true">
                                    </kendo-combobox>
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field mt-0">
                                    <span class="k-text-uppercase dark">
                                        {{'EMAIL-TEMPLATE-LANGUAGE' | translate}}
                                    </span>
                                    <input *ngIf="!isAllowAddUpdate()" id="language" kendoTextBox
                                        formControlName="language" />
                                    <kendo-dropdownlist *ngIf="isAllowAddUpdate()" id="language"
                                        formControlName="language" [data]="languages" [textField]="'text'"
                                        [valueField]="'value'" [valuePrimitive]="true">
                                    </kendo-dropdownlist>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'NAME' | translate}} *
                                    </span>
                                    <input id="name" kendoTextBox formControlName="name" />
                                </label>
                            </div>
                        </div>
                        <div class="mt-2">
                            <label>
                                <span class="k-text-uppercase dark">
                                    {{'EMAIL-TEMPLATE-CONTENT' | translate}} *
                                </span>
                            </label>
                        </div>
                        <div class="pt-2">
                            <kendo-buttongroup [selection]="'single'">
                                <button *ngFor="let size of contentFontSizes;" kendoButton
                                    (click)="setSelectFontSite(size)" [style]="size.style"
                                    [ngClass]="{'k-state-active k-selected': size.class === selectedFontSize.class}"
                                    [toggleable]="true" class="mr-2 k-state-active k-selected custom-state-button">
                                    <i class="fas fa-text-size"></i>
                                </button>
                            </kendo-buttongroup>
                            <kendo-dropdownbutton [data]="tags" [textField]="'text'" class="float-right">
                                {{ 'EMAIL-TEMPLATE-TAGS' | translate }}
                            </kendo-dropdownbutton>
                        </div>
                        <hr />
                        <div class="tab-content">
                            <textarea #templateContent class="w-100 p-0 pt-2 email-content {{selectedFontSize.class}}"
                                id="content" kendoTextArea formControlName="content" style="resize: none;">
                            </textarea>
                        </div>
                    </div>
                    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab *ngIf=" mimeType.value==='HTML'">
                <ng-template kendoTabTitle>
                    <i class=" fas fa-eye"></i>&nbsp;{{ 'FORM-PREVIEW' | translate }}
                </ng-template>
                <ng-template kendoTabContent>
                    <div class="tab-content" innerHTML="{{content.value}}">
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
    </form>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>